import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import type { Link } from "@/lib/types";

export interface CreateManualMarketplaceLinkInput {
  marketplaceCode: string;
  originalUrl: string;
  destinationUrl?: string | null;
}

async function fetchLinks(): Promise<Link[]> {
  const { data, error } = await supabase
    .from("links")
    .select("*")
    .order("created_at", { ascending: false })
    .limit(100);

  if (error) throw error;
  return (data ?? []) as Link[];
}

export function useLinks() {
  return useQuery<Link[], Error>({
    queryKey: ["links"],
    queryFn: fetchLinks,
    staleTime: 30_000,
    refetchOnWindowFocus: true,
  });
}

export async function createManualMarketplaceLink(
  input: CreateManualMarketplaceLinkInput,
): Promise<Link> {
  const { data, error } = await supabase.rpc("create_manual_marketplace_link", {
    p_marketplace_code: input.marketplaceCode,
    p_original_url: input.originalUrl,
    p_destination_url: input.destinationUrl ?? null,
  });

  if (error) {
    throw error;
  }

  if (!data) {
    throw new Error("Link não retornado pelo backend.");
  }

  return data as Link;
}
